import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchRegionCountry = withSuspense(lazy(() => import('./region-country-master-search')));
export default SearchRegionCountry;
